(function () {
  function pushFormSubmit() {
    const el = document.querySelector('.js-umbraco-form-submit[data-dl-event]');
    if (!el || el.dataset.dlPushed === '1') return;

    el.dataset.dlPushed = '1';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: el.dataset.dlEvent,
      form_name: el.dataset.formName,
      form_id: el.dataset.formId || el.dataset.formClientId,
      record_id: el.dataset.recordId
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushFormSubmit);
  } else {
    pushFormSubmit();
  }

  new MutationObserver(pushFormSubmit).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
